class DealerReqDocConfigFilterModel {
    dealerTypeId: string;
    constructor(dealerReqDocConfigFilterModel: DealerReqDocConfigFilterModel) {
        this.dealerTypeId = dealerReqDocConfigFilterModel?.dealerTypeId != undefined ? dealerReqDocConfigFilterModel?.dealerTypeId : '';
    }
}

export { DealerReqDocConfigFilterModel };
